import React from 'react';
import styled from 'styled-components';

const Div = styled.div`
  width: 100%;
  height: 1px;
  opacity: 0.5;
  background-color: #c4c4c4;
`;

function SectionDivider() {
  return <Div />;
}

export default SectionDivider;
